import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { withQuery } from '../../../hoc/withGraphql';
import { flowRight as compose } from 'lodash';

import PaymentDetails from './PaymentDetails';
import CancelDetails from './CancelDetails';

import messages from '../../../locale/messages';
import getContactHostThreadDetails from './getContactHostThreadDetails.graphql';

import arrowImage from '/public/SiteIcons/viewReceiptArrow.svg';

import s from '../ViewMessage.css';

const TripDetails = ({
	title,
	startDate,
	endDate,
	personCapacity,
	listId,
	reservationData,
	contactThreadDetails: { getContactHostThreadDetails, loading },
	basePrice,
	cleaningPrice,
	weeklyDiscount,
	monthlyDiscount,
	userType,
	currency,
	cancelData,
	toCurrency }) => {

	const { formatMessage } = useIntl();
	let checkIn = startDate != null ? moment(startDate).format('DD/MM/YYYY') : '';
	let checkOut = startDate != null ? moment(endDate).format('DD/MM/YYYY') : '';

	let isCancelled = cancelData ? true : false;

	return (
		<div className={cx(s.space4, s.sidebarContainer)}>
			<div className={cx(s.spaceBottom10, s.marginTopNone)}>
				<h4><FormattedMessage {...messages.tripDetails} /></h4>
			</div>
			<div>
				{/* <Link to={"/rooms/" + listId} className={s.timeText}> */}
				<a href={"/rooms/" + listId} target="_blank">
					{title}
				</a>
				{/* </Link> */}
			</div>
			<div>
				<hr className={s.horizondalLine} />
				<div className={cx(s.spaceTop3, s.space3)}>
					<div className={s.tripCheckinCheckout}>
						<div className={s.noPaddingRight}>
							<div className={cx(s.spaceBottom10, s.textBold, s.tripDetailHeading)}>
								<span><FormattedMessage {...messages.checkIn} /></span>
							</div>
							<div className={cx(s.tripDetailGrey, s.checkDate)}>{checkIn}</div>
						</div>
						<div className={cx(s.tripArrowSec, 'commonIconRTL')}>
							<img src={arrowImage} alt='' />
						</div>
						<div className={cx(s.pullRight, s.textLeft, 'viewMessageCheckOutSection')}>
							<div className={cx(s.spaceBottom10, s.textBold, s.tripDetailHeading)}>
								<span><FormattedMessage {...messages.checkOut} /></span>
							</div>
							<div className={cx(s.tripDetailGrey, s.checkDate)}>{checkOut}</div>
						</div>
					</div>
				</div>
				<hr className={s.horizondalLine} />
			</div>
			<div>
				<div className={cx(s.spaceBottom10, s.textBold, s.tripDetailHeading)}>
					<span><FormattedMessage {...messages.guests} /></span>
				</div>
				<div className={cx(s.space3, s.tripDetailGrey)}>
					<span>{personCapacity} {personCapacity > 1 ? formatMessage(messages.guestsCapcity) : formatMessage(messages.guestCapcity)}</span>
				</div>
				{
					!isCancelled && <PaymentDetails
						userType={userType}
						startDate={checkIn}
						endDate={checkOut}
						basePrice={basePrice}
						cleaningPrice={cleaningPrice}
						weeklyDiscount={weeklyDiscount}
						monthlyDiscount={monthlyDiscount}
						currency={currency}
						listingCurrency={currency}
						toCurrency={toCurrency}
						reservationData={reservationData}
						getContactHostThreadDetails={getContactHostThreadDetails?.result}
						loading={loading}
					/>
				}
				{
					isCancelled && <CancelDetails
						userType={userType}
						cancelData={cancelData}
						reservationData={reservationData}
					/>
				}

			</div>
		</div>
	);
}

TripDetails.propTypes = {
	formatMessage: PropTypes.any,
	listId: PropTypes.number.isRequired,
	userType: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	startDate: PropTypes.string.isRequired,
	endDate: PropTypes.string.isRequired,
	personCapacity: PropTypes.number.isRequired,
	basePrice: PropTypes.number.isRequired,
	cleaningPrice: PropTypes.number.isRequired,
	currency: PropTypes.string.isRequired,
	monthlyDiscount: PropTypes.number,
	weeklyDiscount: PropTypes.number,
	cancelData: PropTypes.shape({
		guestServiceFee: PropTypes.number,
		hostServiceFee: PropTypes.number,
		refundToGuest: PropTypes.number,
		payoutToHost: PropTypes.number,
		total: PropTypes.number,
		currency: PropTypes.string,
	}),
	reservationData: PropTypes.any,
};

TripDetails.defaultProps = {
	title: '',
	startDate: null,
	endDate: null,
	personCapacity: 0,
	reservationData: null
};
export default compose(
	withStyles(s),
	withQuery(getContactHostThreadDetails, {
		name: 'contactThreadDetails',
		options: props => ({
			variables: {
				threadId: props.threadId,
				toCurrency: props.toCurrency,
			},
			ssr: false,
			fetchPolicy: 'network-only',
		}),
	}),
)(TripDetails);